// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jGQX","left":"styles_left__3JqXO","right":"styles_right__1jWGv","alert":"styles_alert__1eCBT"};